export const LISTE_SCHEMA_COMPTABLE = {
  title: 'Liste des schémas comptables',
  actions: {
    add: 'Ajouter un schéma comptable',
    archiver: 'Afficher les schémas comptables archivés',
    search: 'Rechercher',
    fusion: 'Fusion',
  },
  tab: {
    libelle: 'Libellé',
    type: 'Type',
    compteNormal: 'Compte normal',
  },
  fusion: {
    title: 'Fusion de schéma compable',
    text: 'Veuillez séléctionner le schéma de référence',
    fusionner: 'Fusionner',
    alert: 'Vous devez sélectionner un schéma comptable de réference pour faire la fusion',
  },
};

export const ADD_SCHEMA_COMPTABLE = {
  titleAdd: 'Ajouter un schéma comptable',
  titleEdit: 'Modifier schéma comptable {libelle}',
  type: {
    achat: 'Achat',
    vente: 'Vente',
  },
  actions: {
    cancel: 'Annuler',
  },
  informationSchemaComptable: {
    title: 'Schéma comptable',
    libelle: 'Libellé',
    type: 'Type',
  },
  informationCompteComptable: {
    title: 'Compte comptable',
    compteNormal: 'Compte normal',
    compteExport: 'Compte à l’export',
    compteTvaDebit: 'Compte TVA debit ou attente',
    tvaSurEncaissement: 'Tva sur encaissement',
    compteTvaEncaissement: 'Compte TVA encaissement',
    produitConstate: 'Produit constaté d’avance',
    compteRemiseHorsRegie: 'Compte remise (hors régie)',
    compteRemiseRegie: 'Compte remise régie',
    compteIntracommunautaire: 'Compte intracommunautaire',
    compteTvaDeductibleIntracommunautaire: 'Compte TVA déductible intracommunautaire',
  },
  parametrageLibelle: {
    title: 'Paramétrage libellé',
    ecriture: 'Libellé d’écriture',
    paramEcriture: {
      title: 'Paramétrage libellé écriture',
      titleReference: 'Paramétrage reference ligne écriture',
      piece: 'Type de la pièce',
      pieceCourt: 'Type de la pièce court (Fa, Av)',
      nom: 'Nom du tiers',
      reference: 'Référence de la pièce',
      nomJuridique: 'Nom juridique du tiers',
      annonceurs: 'Annonceurs',
      periode: 'Période',
      periodeCourt: 'Période courte (mois et année)',
      exit: 'Annuler',
      codeFacture: 'Code de la facture d\'achat',
      codeBail: 'Code du contrat de bail',
      libelle1ereLigneFacture: 'Libellé première ligne facture',
    },
    ecritureTiers: 'Libellé ligne d’écriture de tiers',
    ecritureTva: 'Libellé écriture de TVA',
    ecritureContrepartie: 'Libellé ligne écriture de contrepartie',
    ecritureAcompte: 'Libellé écriture d\'acompte',
    referenceTiers: 'Référence ligne d’écriture de tiers',
    referenceContrepartie: 'Référence ligne écriture de contrepartie',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  success: {
    add: 'Le schéma comptable a été ajouté avec succès.',
    edit: 'Le schéma comptable a été modifié avec succès.',
  },
};

export const DETAIL_SCHEMA_COMPTABLE = {
  title: 'Schéma Comptable - {nomSchemaComptable}',
  actions: {
    edit: 'Modifier',
  },
  informationSchemaComptable: {
    title: 'Schéma comptable',
    type: 'Type :',
    compteNormal: 'Compte normal : ',
    compteExport: 'Compte à l’export :',
    compteTvaDebit: 'Compte TVA debit ou attente :',
    tvaSurEncaissement: 'Tva sur encaissement :',
    compteTvaEncaissement: 'Compte TVA encaissement :',
    produitConstate: 'Produit constaté d’avance :',
    compteRemiseHorsRegie: 'Compte remise (hors régie) :',
    compteRemiseRegie: 'Compte remise régie :',
    compteIntracommunautaire: 'Compte intracommunautaire',
    compteTvaDeductibleIntracommunautaire: 'Compte TVA déductible intracommunautaire',
  },
  parametrageLibelle: {
    title: 'Paramétrage libellé',
    ecriture: 'Libelle d’écriture',
    ecritureTiers: 'Libellé ligne d’écriture de tiers',
    ecritureTva: 'Libellé écriture de TVA',
    ecritureContrepartie: 'Libellé ligne écriture de contrepartie',
    referenceTiers: 'Référence ligne d’écriture de tiers',
    referenceContrepartie: 'Référence ligne écriture de contrepartie',
  },
};
